import * as Search from "./Search/index.js";
import * as Geographic from "./Geographic/index.js";
import * as LeaseDeal from "./LeaseDeal/index.js";
import * as Property from "./Property/index.js";
import * as ShoppingCenter from "./ShoppingCenter/index.js";
import * as SaleComp from "./SaleComp/index.js";
import * as Reports from "./Reports/index.js";
import * as Space from "./Space/index.js";
import * as Tenants from "./Tenants/index.js";
import { DetailDataMode } from "../../../../CoStar/Api/EnterpriseSub2/index.js";
/** CoStar.Api.EnterpriseSub2.Migrated.DetailDataMode */
export { DetailDataMode };
import { AttachmentType } from "../../../../CoStar/Api/EnterpriseSub2/index.js";
/** CoStar.Api.EnterpriseSub2.Migrated.AttachmentType */
export { AttachmentType };
import { PropertyAttributes } from "../../../../CoStar/Api/Search/Result/index.js";
/** CoStar.Api.EnterpriseSub2.Migrated.PropertyAttributes */
export { PropertyAttributes };
import { CommunicationMethod } from "../../../../CoStar/Api/EnterpriseSub2/index.js";
/** CoStar.Api.EnterpriseSub2.Migrated.CommunicationMethod */
export { CommunicationMethod };
import { PhoneNumberType } from "../../../../CoStar/Api/EnterpriseSub2/index.js";
/** CoStar.Api.EnterpriseSub2.Migrated.PhoneNumberType */
export { PhoneNumberType };
import { AdType } from "../../../../CoStar/Api/FusionSearch/Result/index.js";
/** CoStar.Api.EnterpriseSub2.Migrated.AdType */
export { AdType };
/** CoStar.Api.EnterpriseSub2.Migrated.SaleStatus */
export var SaleStatus;
(function (SaleStatus) {
    SaleStatus[SaleStatus["Unknown"] = 0] = "Unknown";
    SaleStatus[SaleStatus["Active"] = 1] = "Active";
    SaleStatus[SaleStatus["Escrow"] = 2] = "Escrow";
    SaleStatus[SaleStatus["Pending"] = 3] = "Pending";
    SaleStatus[SaleStatus["UnderContract"] = 4] = "UnderContract";
    SaleStatus[SaleStatus["Sold"] = 5] = "Sold";
    SaleStatus[SaleStatus["Withdrawn"] = 6] = "Withdrawn";
    SaleStatus[SaleStatus["Leased"] = 7] = "Leased";
    SaleStatus[SaleStatus["Rubbish"] = 12] = "Rubbish";
    SaleStatus[SaleStatus["Occupied"] = 13] = "Occupied";
})(SaleStatus || (SaleStatus = {}));
import { SaleEntityTypes } from "../../../../CoStar/Api/EnterpriseSub2/index.js";
/** CoStar.Api.EnterpriseSub2.Migrated.SaleEntityTypes */
export { SaleEntityTypes };
export { Search, Geographic, LeaseDeal, Property, ShoppingCenter, SaleComp, Reports, Space, Tenants };
